var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogaGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.78 15.7063C10.78 16.5395 11.3863 16.5343 12.5838 16.9349L14.7067 17.6532C14.5822 18.1897 12.1993 22.439 12.1993 22.9242C12.1993 23.5372 12.8932 23.9689 13.5365 23.3167L19.8516 16.9765C20.3581 16.4682 20.715 16.3097 20.715 15.7063C20.715 15.2686 20.2581 15.1164 19.9761 15.0234L16.7883 13.9493C16.8489 13.6881 17.2722 12.9305 17.4191 12.6355L18.7123 10.0396C18.8555 9.7521 19.2957 8.99491 19.2957 8.67829C19.2957 8.06524 18.6018 7.63355 17.9585 8.2858C17.7818 8.46496 17.6397 8.60725 17.4625 8.78514L11.6434 14.626C11.425 14.8452 10.78 15.3631 10.78 15.7063L10.78 15.7063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4834 -0.999984H15.4777C14.0357 -0.997992 12.8647 0.17741 12.8667 1.62047C12.8697 3.05753 14.0425 4.22818 15.4826 4.22818C16.9288 4.2257 18.1035 3.05028 18.1013 1.60897C18.0988 0.170912 16.9238 -1 15.4834 -1L15.4834 -0.999984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4834 26.7719H15.4777C14.0357 26.7739 12.8647 27.949 12.8667 29.3921C12.8697 30.8291 14.0425 32.0001 15.4826 32.0001C16.9288 31.9971 18.1035 30.8226 18.1013 29.3808C18.0988 27.9423 16.9238 26.7719 15.4834 26.7719H15.4834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3606 2.27307H25.3531C23.4114 2.27681 21.8345 3.85856 21.8363 5.80102C21.84 7.73874 23.4201 9.31474 25.3589 9.31474C27.306 9.311 28.8898 7.72925 28.8861 5.78705C28.8831 3.84909 27.3013 2.27307 25.3606 2.27307H25.3606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3606 21.6918H25.3531C23.4114 21.6945 21.8345 23.2775 21.8363 25.2197C21.84 27.1574 23.4201 28.7337 25.3589 28.7337C27.306 28.73 28.8898 27.1475 28.8861 25.206C28.8831 23.2681 27.3013 21.6918 25.3606 21.6918L25.3606 21.6918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09289 15.4396C3.09289 16.292 2.40002 16.9842 1.54585 16.9842C0.692691 16.9842 6.10352e-05 16.292 6.10352e-05 15.4396C6.10352e-05 14.5863 0.692691 13.8943 1.54585 13.8943C2.40002 13.8943 3.09289 14.5863 3.09289 15.4396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.397 5.79394C7.397 6.83589 6.55105 7.68101 5.50775 7.68101C4.46372 7.68101 3.61749 6.83589 3.61749 5.79394C3.61749 4.752 4.46372 3.90662 5.50775 3.90662C6.55105 3.90662 7.397 4.75199 7.397 5.79394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.397 25.2127C7.397 26.2547 6.55105 27.1001 5.50775 27.1001C4.46372 27.1001 3.61749 26.2547 3.61749 25.2127C3.61749 24.1708 4.46372 23.3257 5.50775 23.3257C6.55105 23.3257 7.397 24.1708 7.397 25.2127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3645 10.8109H29.3543C26.8025 10.8154 24.7283 12.8958 24.7311 15.4494C24.7368 17.9955 26.8137 20.0684 29.362 20.0684C31.923 20.0629 34.0034 17.9823 33.9999 15.4299C33.9949 12.8826 31.9153 10.8109 29.3645 10.8109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 33,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogaGame);
export default __webpack_public_path__ + "static/media/loga_game.7da2a3e9cb66cb3af72d29c8f7c0fa73.svg";
export { ForwardRef as ReactComponent };